import React, { Component } from 'react'

import { extractFilterOptions, updateFilterOptions, updateObject } from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import Grid from '@material-ui/core/Grid'
import PageInfo from '../../../../components/PageInfo/PageInfo'
import { withTranslate } from 'react-redux-multilingual'

class ReportBonusSalary extends Component {
  state = {
    filterModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          options: []
        },
        required: false
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          options: []
        },
        required: false
      },
      emp_id: {
        label: this.props.translate('employee'),
        value: '',
        configs: {
          options: []
        },
        required: false
      }
    },
    filterOptions: {
      companyFilterOptions: this.props.companyFilterOptions,
      formFilterOptions: this.props.formFilterOptions,
      levelGroupFilterOptions: this.props.levelGroupFilterOptions,
      orgFilterOptions: this.props.orgFilterOptions,
      positionFilterOptions: this.props.positionFilterOptions,
      empFilterOptions: this.props.empFilterOptions
    }
  }

  componentDidMount = () => {
    this.props.fetchFilter()
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = { ...state }
    if (props.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' }
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.companyFilterOptions
        }
      }
    }
    if (props.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { form_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.formFilterOptions
        }
      }
    }
    if (props.structureFilterOptions !== updatedState.filterOptions.structureFilterOptions) {
      const structureFilter = updatedState.filterControls.param_structure
      let updatedFilterItem = updateFilterOptions(
        props.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          param_structure: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          structureFilterOptions: props.structureFilterOptions
        }
      }
    }
    if (props.levelGroupFilterOptions !== updatedState.filterOptions.levelGroupFilterOptions) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.levelGroupFilterOptions
        }
      }
    }
    if (props.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { org_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.orgFilterOptions
        }
      }
    }
    if (props.positionFilterOptions !== updatedState.filterOptions.positionFilterOptions) {
      const positionFilter = updatedState.filterControls.position_id
      let updatedFilterItem = updateFilterOptions(
        props.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          position_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          positionFilterOptions: props.positionFilterOptions
        }
      }
    }
    if (props.empFilterOptions !== updatedState.filterOptions.empFilterOptions) {
      const employeeFilter = updatedState.filterControls.emp_id
      let updatedFilterItem = updateFilterOptions(
        props.empFilterOptions,
        employeeFilter,
        'emp_id',
        'emp_id',
        { name: 'full_name', code: 'emp_code' },
        'Select employee'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { emp_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          empFilterOptions: props.empFilterOptions
        }
      }
    }

    return updatedState
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appraisalType !== this.props.appraisalType) {
      this.props.fetchCompanyOptions({
        appraisal_type_id: this.props.appraisalType?.value_list_id
      })
    }
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    const updatedItem = { ...filterItem, value: filterValue }
    const updatedFilterControls = updateObject(this.state.filterControls, {
      [itemKey]: updatedItem
    })
    const filterOptions = extractFilterOptions(updatedFilterControls, {
      appraisal_type_id: this.props.appraisalType.value_list_id
    })

    if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchLevelGroupFilterAppraisal(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'form_id') {
      this.props.fetchLevelGroupFilterAppraisal(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filter = extractFilterOptions(this.state.filterControls)
    let par = {
      param_appraisal_type: filter?.appraisal_type_id,
      param_company: filter?.company_id,
      param_form: filter?.form_id,
      param_level_group: filter?.level_group_id,
      param_org: filter?.org_id,
      param_position: filter?.position_id,
      param_emp: filter?.emp_id
    }
    let parameters = {}
    Object.entries(par).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })
    const param = {
      appraisal_type_id: this.props.appraisalType?.value_list_id,
      parameters,
      format: 'xlsx',
      locale: localStorage.getItem('language')
    }
    this.props.reportBonusSalary(param)
    this.closeFilterModal()
  }

  render() {
    let formLoading = <Spinner />
    if (!this.props.loading) {
      formLoading = <PleaseFilter />
    }
 
    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoading}
        />
        <Alert />
        <Card>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs sm md>
                  <PageInfo pageTranslateKey={'reportBonusSalary'} />
                </Grid>
                <Grid item xs sm md={4}>
                  <FilterBar buttonClicked={this.openFilterModal} />
                </Grid>
              </Grid>
            }></CardHeader>
          <CardBody>{formLoading}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const appraisalType = state.reportBonusSalary.appraisalType.find(
    item => item.appraisal_type_code === 'APT02' || item.value_list_code === 'APT02'
  )
  return {
    loading: state.reportBonusSalary.loading,
    filterLoading: state.reportBonusSalary.loadingStates,
    appraisalType,
    companyFilterOptions: state.reportBonusSalary.company,
    formFilterOptions: state.reportBonusSalary.form,
    levelGroupFilterOptions: state.reportBonusSalary.levelGroup,
    orgFilterOptions: state.reportBonusSalary.org,
    positionFilterOptions: state.reportBonusSalary.position,
    empFilterOptions: state.reportBonusSalary.emp,
    report: state.reportBonusSalary.report
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFilter: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptionsForAppraisal(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptionsForAppraisal(filter)),
    fetchOrganizationOptions: filter =>
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filter)),
    fetchPositionOptions: filter => dispatch(actions.fetchPositionOptionsForAppraisal(filter)),
    fetchEmployeeOptions: filter => dispatch(actions.fetchEmployeeOptionsForAppraisal(filter)),
    fetchLevelGroupFilterAppraisal: filter =>
      dispatch(actions.fetchLevelGroupOptionsForAppraisal(filter)),
    reportBonusSalary: filter => dispatch(actions.reportBonusSalary(filter))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ReportBonusSalary))
